import { StripedTable } from "../../../../common/components/functional/stripedTable/StripedTable"; // TODO: change headers to be array of objects (header props, align etc.) or string[]

// TODO: change headers to be array of objects (header props, align etc.) or string[]
type Props = {
  headers: string[];
  rows: JSX.Element[];
  updateSelectedIds?: (ids: string[]) => void;
  selectedIds?: string[];
};

const BulkSalaryIncreaseTable = ({
  headers,
  rows,
  updateSelectedIds,
  selectedIds,
}: Props) => {
  return (
    <StripedTable
      columnHeaders={headers}
      itemRows={rows}
      updateSelectedIds={updateSelectedIds}
      selectedIds={selectedIds}
      selectableRows
    />
  );
};

export default BulkSalaryIncreaseTable;
